import PropTypes from 'prop-types';

import { XIcon } from '../../atoms/Icons';

function OrgUsersFilterField({
  className = '',
  label = '',
  clearLabel = 'Clear filter',
  hasSelection = false,
  onClear = () => {},
  children,
}) {
  const labelId = label ? `${label.replace(/\s+/g, '-').toLowerCase()}-filter-label` : undefined;

  return (
    <div className={`OrgUsers-filterField ${className}`.trim()}>
      {label ? (
        <label className="OrgUsers-filterFieldLabel" id={labelId}>
          {label}
        </label>
      ) : null}
      <div className="OrgUsers-filterFieldInputRow">
        <div className="OrgUsers-filterFieldControl" aria-labelledby={labelId}>
          {children}
        </div>
        {hasSelection ? (
          <button
            type="button"
            className="OrgUsers-filterClear"
            onClick={onClear}
            aria-label={clearLabel}
            title={clearLabel}
          >
            <XIcon className="OrgUsers-filterClearIcon" />
          </button>
        ) : null}
      </div>
    </div>
  );
}

OrgUsersFilterField.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.string,
  clearLabel: PropTypes.string,
  hasSelection: PropTypes.bool,
  onClear: PropTypes.func,
};

export default OrgUsersFilterField;
